import React from "react";
import EmailExpediteurs from "../../EmailExpediteurs/EmailExpediteurs";

function ParametreEmailPage() {
  return <EmailExpediteurs />;
}

export default ParametreEmailPage;
